import { useContext, useEffect, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useRequestIds } from '~/context/srp/InventoryContext';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';
import useSuggestedFilterChipPositions from './useSuggestedFilterChipPositions';

export default function useTrackSuggestedFilterPositions(
  containerRef: React.RefObject<HTMLElement | null>,
  itemCount: number
) {
  const { suggestedFiltersRequestId } = useContext(SuggestedFiltersContext);
  const positions = useSuggestedFilterChipPositions(
    containerRef,
    itemCount,
    suggestedFiltersRequestId
  );
  const trackEvent = useTrackEvent();
  const requestIds = useRequestIds();
  const firedForRequestId = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!positions || firedForRequestId.current === suggestedFiltersRequestId)
      return;

    firedForRequestId.current = suggestedFiltersRequestId;

    trackEvent('Suggested filters', {
      action: 'viewed',
      suggestedFilterPositions: positions,
      suggestedFiltersRequestId,
      totalSuggestedFilters: itemCount,
      ...requestIds
    });
  }, [itemCount, positions, requestIds, suggestedFiltersRequestId, trackEvent]);
}
